<telxl-panel cardClass="h-100" [minHeight]="height()" [maxHeight]="height()">
    <ng-template #cardBody>
        @if (hasPermission()) {
            <div class="p-2">
                <contact-directories-details
                    [contact]="contact()"
                    (updated)="onUpdated($event)"
                />
            </div>
        } @else {
            <div
                class="d-flex flex-column align-items-center justify-content-center overflow-hidden"
                [style.height]="height()"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4">No contact details were found.</div>
            </div>
        }
    </ng-template>
</telxl-panel>
